import { render } from "./Modal1.vue?vue&type=template&id=973b93fa&scoped=true"
import script from "./Modal1.vue?vue&type=script&lang=js"
export * from "./Modal1.vue?vue&type=script&lang=js"

import "./Modal1.vue?vue&type=style&index=0&id=973b93fa&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-973b93fa"]])

export default __exports__